<!-- Copyright (c) ArubaCC - All Rights Reserved. -->
<div class="flex flex-col justify-between items-center w-full h-full text-center px-3">
  <div class="flex flex-col items-center">
    <div class="flex items-end py-14">
      <img [src]="logoPath" [alt]="pageTitle" width="400" height="48" />
    </div>
    <mat-icon class="!w-52 !h-52 sm:!w-72 sm:!h-72" svgIcon="not-found"></mat-icon>
    <h2 class="py-10">{{ 'NOT_FOUND.SOMETHING_WENT_WRONG' | transloco }}</h2>
    <a mat-flat-button color="primary" [routerLink]="['/']">
      <span class="uppercase">{{ 'NOT_FOUND.BACK_HOME' | transloco }}</span>
    </a>
  </div>
</div>
